module.exports = __webpack_public_path__ + "img/kachel-STRESS_PRO12.02c13e89.png";